import Label, {LabelJSON} from "../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/Label";
import {QRLabelMapJSON} from "../../Quantification/QuantificationResultJSON";

export interface NodeLabelJSON {
  label: LabelJSON;
  name: string;
  tree_id: number;
  node_id: string;
}

const FailureNodeLabelJSON: NodeLabelJSON = {
  label: {
    name: 'Failure',
    description: 'Failure Event',
  },
  name: "",
  tree_id: null,
  node_id: "0",
};

const SuccessNodeLabelJSON: NodeLabelJSON = {
  label: {
    name: 'Success',
    description: 'Success Event',
  },
  tree_id: null,
  name: "",
  node_id: "0",
};

export const labelMapDefaults: QRLabelMapJSON = {
  'SQ_F.0': FailureNodeLabelJSON,
  'SQ_S.0': SuccessNodeLabelJSON,
};

export class NodeLabel {

  public label: Label = null;
  public name: string = null;
  public readonly tree_id: number = null;
  public readonly node_id: string = null;

  /**
   * @param {LabelJSON} obj - dictionary object to parse
   * @return {Label}
   */
  static build(obj: NodeLabelJSON): NodeLabel {
    try {
      return new NodeLabel(obj.label, obj.name, obj.tree_id, obj.node_id);
    } catch (e) {
      return new NodeLabel();
    }
  }

  static buildWithDefaults(map: QRLabelMapJSON, key: string): NodeLabel {
    const obj: NodeLabelJSON = map[key];
    return obj ? NodeLabel.build(obj) : NodeLabel.build(labelMapDefaults[key]);
  }

  /**
   * @param {string} labelJSON
   * @param {string} name
   * @param {string} tree_id
   * @param {string} node_id
   */
  constructor(labelJSON: LabelJSON = new Label().toJSON(), name: string = "", tree_id: number = Number.NaN, node_id: string = '') {
    try {
      this.name = name || "";
      this.tree_id = tree_id;
      this.node_id = node_id;
      this.label = Label.build(labelJSON);
    } catch (e) {
      this.name = !this.name ? "" : this.name;
      this.tree_id = !this.tree_id ? Number.NaN : this.tree_id;
      this.node_id = !this.node_id ? '' : this.node_id;
      this.label = !this.label ? new Label() : this.label;
    }
  }

  getLabel(): Label {
    return this.label;
  }

  setLabel(label: Label): void {
    this.label = label;
  }

  /**
   * @return {string}
   */
  getName(): string {
    return this.name;
  }

  /**
   * @param {string} name
   */
  setName(name: string) {
    this.name = name;
  }

  /**
   * @return {LabelJSON} - dictionary object that represents this
   */
  toJSON(): NodeLabelJSON {
    return ({
      label: this.label.toJSON(),
      name: this.name,
      tree_id: this.tree_id,
      node_id: this.node_id,
    });
  }

  clone(): NodeLabel {
    return NodeLabel.build(this.toJSON());
  }

}

export default NodeLabel;
